import type { ApiResponse } from '../types';

type ApiLikeError = {
  message?: string;
  errors?: string[];
  error?: string;
  status?: number;
  statusCode?: number;
};

export const getApiErrorMessage = <T>(
  response: ApiResponse<T> | ApiLikeError | null | undefined,
  fallback = 'Ocurrió un error inesperado'
): string => {
  if (!response) return fallback;
  if (response.message && response.message.trim()) return response.message;
  if (response.errors && response.errors.length > 0) {
    return response.errors.filter(Boolean).join(' | ');
  }
  if (response.error && response.error.trim()) return response.error;
  return fallback;
};

export const getApiErrorTitle = (status?: number): string => {
  switch (status) {
    case 400:
      return 'Solicitud inválida';
    case 401:
      return 'No autenticado';
    case 403:
      return 'Sin permisos';
    case 404:
      return 'No encontrado';
    case 409:
      return 'Conflicto';
    case 422:
      return 'Validación';
    case 500:
      return 'Error del servidor';
    default:
      return 'Error';
  }
};

export const getApiErrors = <T>(
  response: ApiResponse<T> | ApiLikeError | null | undefined
): string[] => {
  if (!response) return [];
  if (response.errors && response.errors.length > 0) {
    return response.errors.filter(Boolean);
  }
  if (response.error) return [response.error];
  if (response.message) return [response.message];
  return [];
};
